import { AppBar } from 'react-admin';
import UserMenu from './UserMenu';

const CustomAppBar = () => {
  return <AppBar userMenu={<UserMenu />} />;
};

export default CustomAppBar;
